import styled from "styled-components";

// Mobile view styles
export const MobileView = styled.div`
  @media (min-width: 769px) {
    display: none;
  }
`;

export const HealthAnalyseContainer = styled.div`
  background-color: #e5f5f2;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  min-height: 100vh;
`;

export const HeaderCard = styled.div`
  background-color: white;
  border-radius: 20px;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 2px 5px #0000001a;
`;

export const LogoWrapper = styled.div`
  margin-left: 20px;
  img {
    height: 35px;
    width: auto;
  }
`;
export const DesktopLogoWrapper = styled.div`
  margin-left: 20px;
  img {
    height: auto;
    width: 150px;
  }
`;
export const StepsCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StepsContainer = styled.div`
  width: 100%;
  min-width: 450px;
  margin-top: 10px;
  @media (max-width: 380px) and (max-height: 800px) {
    min-width: 50% !important;
    margin-right: calc(100vw * 0.1);
  }
`;

export const ContentSection = styled.div`
  flex: 1;
  background: white;
  border-radius: 20px;
  .step-content {
    padding: 20px;
    margin-top: 30px;

    .section-titles-wrapper {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .primary-title {
      font-family: "Rubik", sans-serif !important;
      font-optical-sizing: auto;
      font-style: normal;
      color: #142c1f;
      font-weight: 500;
      font-size: 20px;
      max-width: 500px;
    }

    .accent-subtitle {
      color: #818d88;
      max-width: 500px;
    }

    .small-subtitle {
      color: #142c1f;
      font-size: 14px;
      font-weight: 500;
      max-width: 500px;
    }
  }
  /* box-shadow: 0px 2px 5px #0000001a; */
`;

// Desktop view styles
export const DesktopView = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const DesktopLayout = styled.div`
  display: flex;
  min-height: ${(props) => (props.fullHeight ? "100%" : "100vh")};
  width: 100%;
  background: #e5f5f2;
  padding: 50px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 5px;
`;

export const DesktopSidebar = styled.div`
  flex: 0 0 320px;
  background: white;
  padding: 30px 20px;
  height: calc(-100px + 100vh);
  border-radius: 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 5px;
`;

export const DesktopContent = styled.div`
  flex: 1;
  margin-left: 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 5px;
  border-radius: 20px;
  background: white;
  font-size: 16px;
  .step-content {
    padding: 20px;
    margin-top: 30px;

    .section-titles-wrapper {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .primary-title {
      font-family: "Rubik", sans-serif !important;
      font-optical-sizing: auto;
      font-style: normal;
      color: #142c1f;
      font-weight: 500;
      font-size: 20px;
      max-width: 500px;
    }

    .accent-subtitle {
      color: #818d88;
      max-width: 500px;
    }

    .small-subtitle {
      color: #142c1f;
      font-size: 14px;
      font-weight: 500;
      max-width: 500px;
    }
  }
`;

export const WelcomeText = styled.h1`
  font-size: 24px;
  font-weight: 500;
  color: #333;
  margin: 20px 0 30px 20px;
  line-height: 1.3;
`;

export const StepsLabel = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: #666;
  margin-bottom: 20px;
`;

export const VerticalStepsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const VerticalStepItem = styled.div`
  display: flex;
  position: relative;
  padding-bottom: 30px; /* Increased spacing between items */
  min-height: 60px; /* Minimum height to ensure proper spacing */
`;

export const StepCircle = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: "white";
  border: 4px solid ${(props) => (props.active ? "#2ECF96" : "#d9d9d9")};
  margin-right: 15px;
  flex-shrink: 0;
  margin-top: 4px;
  z-index: 2;
  margin-left: 1px;
`;

export const VerticalLine = styled.div`
  position: absolute;
  top: 22px;
  left: 8px;
  width: 2px; /* Dynamic height based on container */
  height: calc(100% - 20px);
  background-color: ${(props) => (props.active ? "#2ECF96" : "#d9d9d9")};
  z-index: 1;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const StepTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => (props.active ? "#2ECF96" : "#818D88")};
`;

export const StepDescription = styled.span`
  font-size: 14px;
  color: #818d88;
  line-height: 1.4;
`;

export const StepLabel = styled.span`
  margin-top: 5px;
  white-space: nowrap;
  color: ${(props) => (props.active ? "#2ECF96" : "#818D88")};
  font-weight: ${(props) => (props.active ? "500" : "400")};
  font-size: 14px;
`;

export const StepDot = styled.div`
  margin-bottom: 8px;
  border: 2px solid ${(props) => (props.active ? "#2ECF96" : "#C4CFCA")};
  background-color: ${(props) => (props.active ? "#2ECF96" : "white")};
  border-radius: 50%;
  height: 16px;
  width: 16px;
`;

export const StepItem = styled.div`
  margin-top: -9px; /* Positioning for dot to overlap with line */
  align-items: center;
  flex-direction: column;
  display: flex;
`;

export const StepsProgressContainer = styled.div`
  padding: 0 20px;
  max-width: 360px;
  width: 100%;
  margin-bottom: 30px;

  .RSPBprogressBar {
    margin-top: 10px;
  }
`;
